import { render, staticRenderFns } from "./TV.vue?vue&type=template&id=91db6ca4&scoped=true"
import script from "./TV.vue?vue&type=script&lang=js"
export * from "./TV.vue?vue&type=script&lang=js"
import style0 from "./TV.vue?vue&type=style&index=0&id=91db6ca4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91db6ca4",
  null
  
)

export default component.exports